import axiosInstance from './axiosInstance';

export const getAllTutorials = () => axiosInstance.get('/Tutorial/GetAll');
export const getTutorialById = (id) => axiosInstance.get(`/Tutorial/GetById/${id}`);
export const createTutorial = (data) => axiosInstance.post('/Tutorial/Create', data);
export const updateTutorial = (data) => axiosInstance.put('/Tutorial/Update', data);
export const deleteTutorial = (id) => axiosInstance.delete(`/Tutorial/Delete/${id}`);
export const uploadTutorialImage = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/Tutorial/UploadImage', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const uploadTutorialFile = (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return axiosInstance.post('/Tutorial/UploadFile', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const getCategoryCovers = () => axiosInstance.get('/Tutorial/GetCategoryCovers');
export const setCategoryCover = (category, coverUrl) => axiosInstance.post('/Tutorial/SetCategoryCover', { category, coverUrl });
